export default class ModelOptions {
    private domParser: DOMParser;

    private buffer: {
        cache: {
            [key: string]: HTMLOptionElement[];
        };
    } = { cache: {} };

    constructor() {
        this.domParser = new DOMParser();
    }

    /**
     * paginate section to iterate over all products
     * @param url
     * @param section
     */
    public async fetch(url: string, section: string): Promise<HTMLOptionElement[]> {
        const cacheKey = `${url}|${section}`;
        if (this.buffer.cache[cacheKey]) {
            return new Promise((resolve) => resolve(this.buffer.cache[cacheKey]));
        } else {
            const promises = [];
            for (let i = 1; i <= 10; i++) {
                promises.push(
                    new Promise((resolve) => {
                        fetch(`${url}&page=${i}`)
                            .then((response) => response.json())
                            .then((data) => {
                                const doc = this.domParser.parseFromString(data[section], "text/html");
                                resolve([...doc.querySelectorAll<HTMLOptionElement>("option")]);
                            });
                    })
                );
            }
            this.buffer.cache[cacheKey] = await Promise.all(promises).then(this.parseResult.bind(this));
            return this.buffer.cache[cacheKey];
        }
    }

    /**
     * flatten and sort option arrays
     * @param values
     * @private
     */
    private parseResult(values: HTMLOptionElement[][]): HTMLOptionElement[] {
        const flatFilters = values.filter((v) => v.length > 0).flat();

        const categoryVendorMap = flatFilters.reduce((acc: Set<string>, cur: HTMLOptionElement) => {
            JSON.parse(cur.dataset.categoryVendorMap ?? "[]").forEach((v: string) => {
                acc.add(v);
            });
            delete cur.dataset.categoryVendorMap;
            return acc;
        }, new Set());

        const options = flatFilters.reduce((acc: HTMLOptionElement[], cur: HTMLOptionElement) => {
            if (!acc.find((c) => c.value === cur.value)) {
                acc.push(cur);
            }
            return acc;
        }, []);

        options.sort((a: HTMLOptionElement, b: HTMLOptionElement) => {
            if (a.value > b.value) return 1;
            if (b.value > a.value) return -1;
            return 0;
        });

        if (options.length) {
            options[0].dataset.categoryVendorMap = JSON.stringify([...categoryVendorMap]);
        }

        return options;
    }
}
